import "./utils/rem";
//import "./utils/weixin";
import { createApp } from 'vue';
import router from "./router/router"
import {
    Loading,
    Skeleton,
    Toast,
    Col,
    Row,
    Tab,
    Tabs,
    List,
    Cell,
    CellGroup,
    PullRefresh,
    Tag,
    Image as VanImage,
    Swipe, 
    SwipeItem,
    Icon,
    Sticky 
} from 'vant';

import App from './App.vue'
import '@vant/touch-emulator';

import store from "./store/store";

const app = createApp(App);

app.use(store);
app.use(router);

app.use(Loading);
app.use(Skeleton);
app.use(Toast);
app.use(Col);
app.use(Row);
app.use(Tab);
app.use(Tabs);
app.use(List);
app.use(Cell);
app.use(CellGroup);
app.use(PullRefresh);
app.use(Tag);
app.use(VanImage);
app.use(Swipe);
app.use(SwipeItem);
app.use(Icon);
app.use(Sticky);


app.mount('#app')
